__turbopack_context__.v({
  "chip": "ueNQCa_chip",
  "chips": "ueNQCa_chips",
  "closeBtn": "ueNQCa_closeBtn",
  "fullTrigger": "ueNQCa_fullTrigger",
  "iconTrigger": "ueNQCa_iconTrigger",
  "iconTriggerBtn": "ueNQCa_iconTriggerBtn",
  "input": "ueNQCa_input",
  "inputBox": "ueNQCa_inputBox",
  "lupaIcon": "ueNQCa_lupaIcon",
  "noResults": "ueNQCa_noResults",
  "overlay": "ueNQCa_overlay",
  "overlayBrand": "ueNQCa_overlayBrand",
  "overlayContent": "ueNQCa_overlayContent",
  "overlayEnd": "ueNQCa_overlayEnd",
  "overlayHeader": "ueNQCa_overlayHeader",
  "overlayHeaderInner": "ueNQCa_overlayHeaderInner",
  "overlayIconBtn": "ueNQCa_overlayIconBtn",
  "overlaySearchForm": "ueNQCa_overlaySearchForm",
  "overlaySearchRowMobile": "ueNQCa_overlaySearchRowMobile",
  "overlayStart": "ueNQCa_overlayStart",
  "overlayWordmark": "ueNQCa_overlayWordmark",
  "productGrid": "ueNQCa_productGrid",
  "productItem": "ueNQCa_productItem",
  "searchBandBar": "ueNQCa_searchBandBar",
  "searchBtn": "ueNQCa_searchBtn",
  "section": "ueNQCa_section",
  "sectionTitle": "ueNQCa_sectionTitle",
  "suggestion": "ueNQCa_suggestion",
  "suggestionArrow": "ueNQCa_suggestionArrow",
  "suggestionList": "ueNQCa_suggestionList",
  "suggestionText": "ueNQCa_suggestionText",
  "suggestionsBlock": "ueNQCa_suggestionsBlock",
  "wrapper": "ueNQCa_wrapper",
});
